// https://abtesting.spotify.net/features/2522
export const CITY_TARGETING = 'adstudio-city-targeting';

// https://abtesting.spotify.net/features/2498
export const ADGEN_PRICER = 'adgen-pricer';

// https://abtesting.spotify.net/features/2581
export const FAN_TARGETING = 'adstudio-fan-targeting';



// WEBPACK FOOTER //
// ./src/config/featureFlags.js